import React, { useState } from 'react'
import logo from '../../assets/Stalbanslogo.png'
import { loginUserAPI } from '../../serverApi/server'
import { useNavigate } from 'react-router-dom'
import { encryptToken, setCookie, decryptToken, encryptPayload } from '../../components/Helper/Helpers'


const AdminLogin = () => {
  const [incorrectPassword, setIncorrectPassword] = useState('');
  const [loginSuccessful, setLoginSuccessful] = useState(false);
  const navigate = useNavigate()
  const id = null;
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value.replace(/\s+/g, '') // Restrict spaces
    }));
    if (name === 'password') {
      setIncorrectPassword('');
    }
  };

  const handleSubmit = async (e) => {
    var login_type = 'admin'
    var selectedOptions = null
    e.preventDefault();
    try {
      const login_payload = JSON.stringify({ email: loginData.email, password: loginData.password, login_type: login_type});
      const encryptedPayload = await encryptPayload(login_payload)
      const response = await loginUserAPI(
        encryptedPayload
      );
      var decrypted_login_response_detail = await decryptToken(response.data.encrypted_response)
      var decrypted_login_response = JSON.parse(decrypted_login_response_detail)
      if (decrypted_login_response && decrypted_login_response.user_role === 'admin' && decrypted_login_response.client_status_code === 200) {
        // const encryptedAccessToken = encryptToken(response.data.access_token);
        // const encryptedRefreshToken = encryptToken(response.data.refresh_token);
        const encryptedAccessToken = decrypted_login_response.access_token
        const encryptedRefreshToken = decrypted_login_response.refresh_token
        setCookie('_patsap', encryptedAccessToken, 100);
        setCookie('_prtsap', encryptedRefreshToken, 364);
        setCookie('_puisap', decrypted_login_response.user_id, 364);
        setCookie('_prsap', decrypted_login_response.user_role, 364);
        setLoginSuccessful(true);
        navigate('/admin/dashboard');
      } else {
        setIncorrectPassword(decrypted_login_response.message || 'Incorrect email (or) password');
      }
    } catch (error) {
      setIncorrectPassword('Incorrect email (or) password');
    }
  };

  return (
    <div className='w-full h-screen bg-blue-50 flex items-center justify-center'>
      <div className='bg-white py-8 px-10 rounded-lg shadow-[0px_2px_10px_0px_rgba(0,0,0,0.2)] shadow-blue-300'>
        <div className='mb-6 flex flex-col gap-4 items-center justify-center'>
          <img src={logo} alt="logo" className='w-36'/>
          <h1 className='font-medium text-neutral-500'>Stalbans printing Admin Panel</h1>
        </div>
        <form onSubmit={handleSubmit} className='w-64'>
          <input
            type="email"
            name="email"
            value={loginData.email}
            onChange={handleChange}
            placeholder='Username'
            required
            className="focus:outline-none text-neutral-600 px-2 py-1 sm:py-2 rounded w-full border-neutral-300 border mb-4"
          />

          <input
            type="password"
            name="password"
            value={loginData.password}
            onChange={handleChange}
            placeholder='Password'
            required
            className={`focus:outline-none relative text-neutral-600 px-2 py-1 sm:py-2 rounded w-full border-neutral-300 border ${incorrectPassword ? 'mb-0' : 'mb-4'}`}
          />
          {incorrectPassword && (
            <p className="text-red-500 text-sm">{incorrectPassword}</p>
          )}

          <button
            type="submit"
            className="block rounded focus:border-opacity-100 border-neutral-400 border-[3px] border-opacity-0 w-full px-2 py-1 text-white bg-blue-400 hover:bg-blue-600 duration-200 mb-2"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminLogin
